import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  current,
} from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

export interface ValidationErrorResponse {
  status: "error";
  message: string;
  expected_columns: string[];
  uploaded_columns: string[];
  mismatches: {
    position: number;
    expected: string;
    actual: string;
  }[];
}
interface sortObj {
  heading: string;
  sortType: string;
}

export interface KddPageData {
  columns: string[];
  values: string[][];
  offset: number;
  limit: number;
  total_pages: number;
  page: number;
  hasMore: boolean;
}

interface OptionType {
  value: string;
  label: string;
}
export interface DateOptionsResponse {
  date_options: string[];
  hasMore: boolean;
  limit: number;
  offset: number;
  total: number;
}
interface SortState {
  columnsSort: { [key: string]: "asc" | "desc" | undefined }; // stores sort direction per column
}
export interface TitleOptionsResponse {
  title_options: string[];
  hasMore: boolean;
  limit: number;
  offset: number;
  total: number;
}
export interface FileNameOptionsResponse {
  file_name_options: string[];
  hasMore: boolean;
  limit: number;
  offset: number;
  total: number;
}

interface DealData {
  _id: null | string;
  title: string;
  description: string;
  routes: string;
  label_metadata: string;
  table_name: string;
  file_extenstion: string;
  columns: string[];
  is_active: boolean;
}
interface KddTileData {
  _id: null | string;
  title: string;
  description: string;
  routes: string;
  label_metadata: string;
  table_name: string;
  file_extenstion: string;
  columns: string[];
  is_active: boolean;
}
interface TitleSortBy {
  heading: string;
  sortType: string;
}

interface UploadState {
  data: KddPageData | null;
  SearchRelatedDataonKdd: DealData[];
  page_data: KddPageData[];
  offset: number;
  limit: number;
  totalItems?: number;
  FecthDealData: DealData[];
  FetchKddData: KddTileData[];
  ValidationOfFile: any;
  validationError: ValidationErrorResponse | any;
  ValidationLoading: boolean;
  loading: boolean;
  success: boolean;
  error: string | null;
  mode?: string;
  openViewBox: boolean;
  modalTitle: String | null;
  fileData: File | null | any;
  validationStatus: "idle" | "loading" | "success" | "error" | any;
  uploadedFileName: string;
  fileInputClear: boolean;
  columnsOfExcelSheet: any | string[];
  rowsOfExcelSheet: any;
  totalRows: number;
  currentPage: number;
  uploadFileData: any;
  isSubmitDisabledForPreview: boolean;
  kddDataWithPagination: any;
  message: string;
  isUploading: boolean;
  status: number;
  hasMore: boolean;
  titleSortBy: sortObj;
  detail: any;
  DateOption: any;
  kddTitleOption: any;
  filenameOptions: any;
  selectedDateList?: OptionType[];
  selectedTitleList?: OptionType[];
  selectedFileName?: OptionType[];
  columnsSort: any;
  PreviewExistingPopupOpen: boolean;
  sortState?: sortObj;
  filename: any;
  scrolling: boolean;
  GetKddIconData: any;
  kddLoading:boolean;
}

const initialState: UploadState = {
  data: null,
  loading: false,
  success: false,
  error: null,
  mode: "",
  FecthDealData: [],
  FetchKddData: [],
  openViewBox: false,
  modalTitle: null,
  fileData: null,
  validationStatus: "idle",
  ValidationOfFile: "",
  ValidationLoading: false,
  validationError: null,
  fileInputClear: false,
  uploadedFileName: "",
  columnsOfExcelSheet: "",
  rowsOfExcelSheet: [],
  totalRows: 0,
  currentPage: 1,
  uploadFileData: [],
  isSubmitDisabledForPreview: false,
  kddDataWithPagination: [],
  page_data: [],
  offset: 0,
  limit: 10,
  totalItems: 10,
  message: "",
  isUploading: false,
  status: 0,
  SearchRelatedDataonKdd: [],
  hasMore: false,
  titleSortBy: {
    heading: "",
    sortType: "asc",
  },
  detail: "",
  DateOption: [],
  kddTitleOption: [],
  filenameOptions: [],
  selectedDateList: [],
  selectedTitleList: [],
  selectedFileName: [],
  columnsSort: {},
  PreviewExistingPopupOpen: false,
  sortState: {
      heading: "KINDLE_ASIN",
    sortType: "desc",
  },
  filename: "",
  scrolling: false,
  GetKddIconData: [],
  kddLoading:false
};
//For load data in kdd-Table- send file as payload
export const uploadFileKdd = createAsyncThunk(
  "kdd/uploadFile",
  async (formData: FormData, thunkAPI) => {
    try {
      const response = await axios.post(`${API.UPLOADKDDFILE}`, formData);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || "Upload failed");
    }
  }
);
export const GetKddIconData = createAsyncThunk(
  "GetKddIconData",
  async (title: string, thunkAPI) => {
    try {
      const response = await axios.post(
        "/guideline/guideline/kdd",
        { title },
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data; // Blob
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const ValisationOfASAPexcelFile = createAsyncThunk(
  "ValisationOfASAPexcelFile",
  async (file: File, { rejectWithValue }) => {
    const formData = new FormData();
       formData.append("asap_file", file);

    try {
      const response = await axios.post(`${API.FileValidationOfAsap}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response, "response");
      if (response.data.status === "error") {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error: any) {
      const message = error.response?.data?.detail;
      return rejectWithValue(message);
    }
  }
);

export const SearchApiKddSubModule = createAsyncThunk(
  "search/deal",
  async (searchTerm: string, thunkAPI) => {
    console.log(searchTerm, "searchterm");
    try {
      const response = await axios.get(
        `${API.GETSUBMODULESEARCH}?search=${searchTerm}`
        // `${API.GETDEALSEARCHAPI}/search=${searchTerm}`
      );
      console.log("Search results:", response.data);
      return response.data;
    } catch (err) {
      console.error("Search API failed:", err);
      return thunkAPI.rejectWithValue("Search API failed"); // return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);
export const fetchKddDataPagination = createAsyncThunk<
  KddPageData,
  {
    page?: number;
    limit?: number;
    heading?: string;
    sortType?: string;
    filters?: { TITLE?: any; DATE?: any; FILE_NAME?: any };
  }
>(
  "data/fetchData",
  async (
    { page = 1, limit = 10, heading = "", sortType = "asc", filters = {} },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<KddPageData>(`${API.GETKDDDATA}`, {
        page,
        limit,
        heading,
        sortType,
        filters,
      });

      console.log("scrollllllll", page);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);

//It fetches Deal-Tile: Title and route
export const fetchDealData = createAsyncThunk(
  "fetchDealData",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${API.FETCHDEALDATA}`, {
        headers: {
          "ngrok-skip-browser-warning": "true",
          "Content-Type": "application/json",
        },
      });
      console.log(response, "response");
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);
//It fetch KDD data - title
export const fecthKddData = createAsyncThunk(
  "fecthKddData",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${API.FETCHKDDTILEDATA}`, {
        headers: {
          "ngrok-skip-browser-warning": "true",
          "Content-Type": "application/json",
        },
      });
      console.log(response, "response");
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

//Validation Api for excel file
export const validateExcelFile = createAsyncThunk(
  "upload/validateExcelFile",
  async (file: File, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append("kdd_file", file);
    try {
      const response = await axios.post(
        `${API.FILEVALIDATIONEXCELFILE}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response, "response");
      if (response.data.status === "error") {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error: any) {
      const message = error.response?.data?.detail;
      return rejectWithValue(message);
    }
  }
);

// export const FetchDate = createAsyncThunk(
//   "FetchDate",
//   async (
//     params: { page?: number; limit?: number; searchTerm?: string } = {},
//     { rejectWithValue }
//   ) => {
//     console.log("page in reducer", params.page);
//     try {
//       const queryParams = [];

//       if (params.page !== undefined) queryParams.push(`page=${params.page}`);
//       if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
//       if (params.searchTerm !== undefined)
//         queryParams.push(`searchTerm=${params.searchTerm}`);

//       const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

//       const response = await axios.get(
//         `${API.GETDATEOPTIONSINKDD}${queryString}`
//       );

//       return { data: response.data, page: params.page ?? 1 };
//     } catch (err: any) {
//       if (err.response?.data) {
//         return rejectWithValue(err.response.data);
//       }
//       return rejectWithValue("error occurred");
//     }
//   }
// );
// export const FetchTitleOptions = createAsyncThunk(
//   "FetchTitleOptions",
//   async (
//     params: { page?: number; limit?: number; searchTerm?: string } = {},
//     { rejectWithValue }
//   ) => {
//     console.log("page in reducer", params.page);
//     try {
//       const queryParams = [];

//       if (params.page !== undefined) queryParams.push(`page=${params.page}`);
//       if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
//       if (params.searchTerm !== undefined)
//         queryParams.push(`searchTerm=${params.searchTerm}`);

//       const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

//       const response = await axios.get(
//         `${API.GETTITLEOPTIONSINKDD}${queryString}`
//       );

//       return { data: response.data, page: params.page ?? 1 };
//     } catch (err: any) {
//       if (err.response?.data) {
//         return rejectWithValue(err.response.data);
//       }
//       return rejectWithValue("error occurred");
//     }
//   }
// );

// export const FetchTitleOptions = createAsyncThunk(
//   "FecthTitleoptions",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(API.GETTITLEOPTIONSINKDD);
//       return response;
//     } catch (err: any) {
//       if (err.response && err.response.data) {
//         return rejectWithValue(err.response.data);
//       }
//       return rejectWithValue("error occurred");
//     }
//   }
// );
// export const FetchFileNameOptions = createAsyncThunk(
//   "FetchFileNameOptions",
//   async (
//     params: { page?: number; limit?: number; searchTerm?: string } = {},
//     { rejectWithValue }
//   ) => {
//     console.log("page in reducer", params.page);
//     try {
//       const queryParams = [];

//       if (params.page !== undefined) queryParams.push(`page=${params.page}`);
//       if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
//       if (params.searchTerm !== undefined)
//         queryParams.push(`searchTerm=${params.searchTerm}`);

//       const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

//       const response = await axios.get(
//         `${API.GETFILENAMEOPTIONSINKDD}${queryString}`
//       );

//       return { data: response.data, page: params.page ?? 1 };
//     } catch (err: any) {
//       if (err.response?.data) {
//         return rejectWithValue(err.response.data);
//       }
//       return rejectWithValue("error occurred");
//     }
//   }
// );
// export const FetchFileNameOptions = createAsyncThunk(
//   "FetchFileNameOptions",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(API.GETFILENAMEOPTIONSINKDD);
//       return response;
//     } catch (err: any) {
//       if (err.response && err.response.data) {
//         return rejectWithValue(err.response.data);
//       }
//       return rejectWithValue("error occurred");
//     }
//   }
// );

const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setopenViewBox: (state, action) => {
      state.openViewBox = action.payload;
    },
    setModalTitle: (state, action) => {
      state.modalTitle = action.payload;
    },
    setfileData: (state, action) => {
      state.fileData = action.payload;
    },
    clearValidatorErrors: (state) => {
      state.validationError = null;
      state.validationStatus = null;
    },
    setfileInputClear: (state, action) => {
      state.fileInputClear = action.payload;
    },
    setColumnsOfExcelSheet: (state, action) => {
      state.columnsOfExcelSheet = action.payload;
    },
    setrowsOfExcelSheet: (state, action) => {
      state.rowsOfExcelSheet = action.payload;
    },
    setUploadedFileName: (state, action: PayloadAction<string>) => {
      state.uploadedFileName = action.payload;
    },
    setCurrentPage: (state, action) => {
      console.log("currentPageinReducer is being set", action.payload);
      state.currentPage = action.payload;
    },
    setIsSubmitDisabledForPreview: (state, action) => {
      state.isSubmitDisabledForPreview = action.payload;
      console.log("Set Disabled For Preview:", action.payload);
    },
    setIsUploading: (state, action) => {
      state.uploadFileData = action.payload;
    },
    titleListSortByDesc: (state, action) => {
      state.titleSortBy = action.payload;
      console.log(action.payload, "titlesortby");
    },
    setValidationError: (state, action) => {
      state.validationError = action.payload;
    },
    resetKddPagination: (state) => {
      state.data = null;
      state.currentPage = 1;
      // state.hasMore = true;
      state.error = null;
    },
    resetValidationError: (state) => {
      state.validationError = null;
      state.validationStatus = "idle";
      state.ValidationOfFile = null;
      state.ValidationLoading = false;
      state.detail = null;
    },
    updateselectedDateList: (state, action) => {
      state.selectedDateList = action.payload;
    },
    updateselectedTitleList: (state, action) => {
      state.selectedTitleList = action.payload;
    },
    updateselectedFileName: (state, action) => {
      state.selectedFileName = action.payload;
    },
    resetSEGPage: (state) => {
      state.currentPage = initialState.currentPage;
    },
    setSortDirection: (
      state,
      action: PayloadAction<{ column: string; sortType: "asc" | "desc" }>
    ) => {
      const { column, sortType } = action.payload;
      state.columnsSort[column] = sortType;
    },
    setPreviewExistingPopupOpen: (state, action) => {
      state.PreviewExistingPopupOpen = action.payload;
    },
    setSortState: (state, action) => {
      state.sortState = action.payload;
    },
    setscrolling: (state, action) => {
      state.scrolling = action.payload;
    },
    clearKddState:(state)=>{
      state.columnsOfExcelSheet=[]
      state.rowsOfExcelSheet=[]
      state.uploadedFileName=""
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFileKdd.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(uploadFileKdd.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.uploadFileData = action.payload;
        state.message = action.payload.message;
        console.log(action.payload.message, "msggg");
        console.log(action.payload, "uploadapi");
        // state.
      })
      .addCase(uploadFileKdd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(fetchDealData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDealData.fulfilled, (state, action) => {
        state.loading = false;
        state.FecthDealData = action.payload;
        console.log(action.payload, "action.payload");
      })
      .addCase(fetchDealData.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(fecthKddData.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(fecthKddData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.FetchKddData = action.payload;
        console.log(action.payload, "FetchkddActions");
      })
      .addCase(fecthKddData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(validateExcelFile.pending, (state) => {
        state.validationStatus = "loading";
        state.validationError = null;
        state.ValidationOfFile = null;
        state.ValidationLoading = true;
      })
      .addCase(validateExcelFile.fulfilled, (state, action) => {
        state.validationStatus = "success";
        state.ValidationOfFile = action.payload;
        state.validationError = action.payload.error;
        state.ValidationLoading = false;
        state.detail = action.payload.detail;
      })
      .addCase(validateExcelFile.rejected, (state, action) => {
        state.validationStatus = "error";
        state.ValidationOfFile = null;
        state.validationError = action.payload;
        console.log(action.payload, "validationmsg");
        state.ValidationLoading = false;
      })
      .addCase(fetchKddDataPagination.pending, (state) => {
        state.kddLoading=true;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKddDataPagination.fulfilled, (state, action) => {
        state.loading = false;
         state.kddLoading=false;
        state.hasMore = action.payload.hasMore;
        // state.currentPage = action.payload.page;
        console.log("currentPageinReducer", state.currentPage);
        if (state.currentPage == 1 || !state.data) {
          state.data = action.payload;
        } else {
          state.data = {
            ...action.payload,
            values: [...state.data.values, ...action.payload.values],
          };
        }
      })

      .addCase(fetchKddDataPagination.rejected, (state, action) => {
        state.loading = false;
         state.kddLoading=false;
        state.error = action.payload as string;
      })
      .addCase(SearchApiKddSubModule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SearchApiKddSubModule.fulfilled, (state, action) => {
        state.SearchRelatedDataonKdd = action.payload;
        console.log(action.payload, "searchdealapi");
        state.loading = false;
      })
      .addCase(SearchApiKddSubModule.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload || null;
      })
      .addCase(GetKddIconData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetKddIconData.fulfilled, (state, action) => {
        state.GetKddIconData = action.payload;
        console.log(action.payload, "GetKddIconData");
        state.loading = false;
      })
      .addCase(GetKddIconData.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload || null;
      })
        .addCase(ValisationOfASAPexcelFile.pending, (state) => {
              state.validationStatus = "loading";
              state.validationError = null;
              state.ValidationOfFile = null;
              state.ValidationLoading = true;
            })
            .addCase(ValisationOfASAPexcelFile.fulfilled, (state, action) => {
              state.validationStatus = "success";
              state.ValidationOfFile = action.payload.data;
              state.validationError = action.payload.error;
              // console.log(action.payload.error,action.payload.data,'action.payload')
              state.validationError = action.payload;
              state.ValidationLoading = false;
              // state.detail = action.payload.detail;
            })
            .addCase(ValisationOfASAPexcelFile.rejected, (state, action) => {
              state.validationStatus = "error";
              state.ValidationOfFile = null;
              state.validationError = action.payload;
              console.log(action.payload, "validationmsg");
              state.ValidationLoading = false;
            })
  },
});

export const {
  setMode,
  setopenViewBox,
  setModalTitle,
  setfileData,
  clearValidatorErrors,
  setfileInputClear,
  setColumnsOfExcelSheet,
  setrowsOfExcelSheet,
  setUploadedFileName,
  setIsSubmitDisabledForPreview,
  setIsUploading,
  titleListSortByDesc,
  setValidationError,
  updateselectedDateList,
  updateselectedTitleList,
  updateselectedFileName,
  setCurrentPage,
  resetValidationError,
  resetKddPagination,
  resetSEGPage,
  setSortDirection,
  setPreviewExistingPopupOpen,
  setSortState,
  setscrolling,clearKddState
} = uploadSlice.actions;

export default uploadSlice.reducer;
